<template>
  <div class="p-3 md:p-6 lg:p-12 rounded-lg bg-zinc-50 flex flex-col">
    <p class="text-xl font-medium">
      {{ blog.title }}
    </p>
    <p class="font-light">
      {{ useDateFormat(blog.date, 'DD/MM/YYYY') }}
    </p>
    <p class="line-clamp-3 flex-1 pt-4">
      {{ blog.brief }}
    </p>
    <ButtonGeneral
      text="Read blog..."
      class="mt-4"
      :to="blog._path"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{ blog: Blog }>()
</script>

<style scoped>

</style>
